import React from "react";
import { useTranslation } from "react-i18next";
import { useGetAvailableQuestions } from "../../hooks/groups/Questions";
import GroupQuestionsListItem from "./GroupQuestionsListItem";
import LoadingSpinner from "../global/LoadingSpinner";

function GroupQuestionsAllList({ id, exclude, moduleId,  onAddToModule }) {
    const { t, i18n } = useTranslation();
    const { data, isLoading, isError } = useGetAvailableQuestions(id);

    const handleAddToModules = (e) => {
        onAddToModule?.(e);
    }

    if (isLoading) return <LoadingSpinner/>
    if (isError) return 'An error has occurred: ' + isError.message;

    //if (data) return <pre>{JSON.stringify(data, null, 2)}</pre>;

    return (<>
        <div>
            {data.map((question, key) => {
                if (!exclude.includes(question.id)) 
                return (<GroupQuestionsListItem key={`${id?id:"new"}__${key}`}  index={key} id={question.id} moduleId={moduleId} type={question.answer_type} text={question.text} isSortable={false} onAddToModule={(e) => { handleAddToModules(e) }} />)
                else return null;
            })}
        </div>
    </>
    );
}

export default GroupQuestionsAllList;
